import Checkbox from './checkbox/CheckboxInput';
import Field from './field/InputField';
import Image from './image/ImageInput';
import Mask from './mask/MaskInput';
import Number from './number/NumberInput';
import Select from './select/SelectInput';
import Slider from './slider/InputSlider';
import Switch from './switch/SwitchInput';
import Editor from './text-editor/InputTextEditor';
import Text from './text/TextInput';
import ComplexWrapper from './wrapper/complex/ComplexInputWrapper';

export default {
  Text,
  Number,
  Mask,
  Select,
  Checkbox,
  ComplexWrapper,
  Field,
  Image,
  Switch,
  Editor,
  Slider,
};
